class ArchiveMessageWorkflow {
    constructor($injector) {
        this.injector = $injector;
        this.alert = this.injector.get('Alert');
        this.api = this.injector.get('$http');
        this.state = this.injector.get('$state');
        this.sweetAlert = this.injector.get('SweetAlert');
        this.translate = this.injector.get('$translate');

        this.key = 'archive-message';
        this.title = this.translate.instant('general.verbs.archive');
        this.level = 'highlight';
        this.icon = 'fal fa-trash-alt';
        this.order = 45;
    }

    action(message) {
        const translatedValue = (path, params) => {
            return this.translate.instant(`messages.workflows.ask-to-archive-message.${path}`, params);
        };

        this.alert.animatedAlert(
            translatedValue('title'),
            translatedValue('content', { message_subject: message.subject || 'message' }),
            'attention',
            {
                confirmButtonText: translatedValue('confirm'),
                cancelButtonText: translatedValue('cancel'),
                wait: true
            }).then(() => {
                return this.api.delete(`messages/${ message.id }`)
                    .then(() => {
                        this.alert.success('Success', 'Message archived');
                        this.state.go(message.type === 'sms' ? 'app.messages.sms.index' : 'app.messages.index');
                    }, err => this.alert.handle(err));
            }, () => ({}))
    }

}

angular
    .module('festzelt-os.modules.messages')
    .factory('archiveMessage', [
        '$injector',
        ($injector) => new ArchiveMessageWorkflow($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/messages/workflows/details/archive.js